export function degToRad(deg) {
  return deg * (Math.PI / 180);
}

export function distanceBetweenPoints(A, B) {
  return Math.hypot(B.x - A.x, B.y - A.y);
}
